import { useContext, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { addNode } from "../utils/flowSlice";
import { DarkModeContext } from "../context/DarkModeContext";
import { ImageIcon } from "lucide-react";

const Image = () => {
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    // console.log(fileInputRef.current);
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      dispatch(addNode({ type: "imageNode", imageUrl: imageUrl }));
      // Handle file upload logic here
    }
  };
  const { darkMode } = useContext(DarkModeContext);

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("image")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition opacity-50 ${darkMode ? "text-neutral-600" : "text-white"
          }`}
        onClick={handleButtonClick}
      >
        <ImageIcon size={24} />
      </button>
      {activeTooltip === "image" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2 z-10">
          Image
        </span>
      )}
      <input
        ref={fileInputRef}
        accept="image/*"
        type="file"
        className="hidden"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default Image;
